import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { PATH } from "../../router/path";
import { addDatadogAction } from "../../services/datadog";
import Condition from "../Conditional/Condition";
import DiningTimer from "../DiningTimer/DiningTimer";
import "./HamburgerDrawer.scss";

const HamburgerDrawer: FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { state: showDiningTimer } = useConfigContext(
		(state) => state.config?.show_dining_timer ?? true
	);

	const handleToggle = () => setIsOpen((prev) => !prev);
	const handleClose = () => setIsOpen(false);

	const handleCart = () => {
		addDatadogAction("hamburger.cart_click");
		handleClose();
		navigate(PATH.CART);
	};

	const handleOrderHistory = () => {
		handleClose();
		navigate(PATH.BILL);
	};

	return (
		<>
			<button
				className={`HamburgerButton ${isOpen ? "HamburgerButton--open" : ""}`}
				data-testid="hamburger-button"
				onClick={handleToggle}
				aria-label={isOpen ? "Close menu" : "Open menu"}
			>
				<span className="HamburgerIcon HamburgerIcon--top" />
				<span className="HamburgerIcon HamburgerIcon--mid" />
				<span className="HamburgerIcon HamburgerIcon--bot" />
			</button>

			<button
				type="button"
				className={`DrawerOverlay ${isOpen ? "DrawerOverlay--visible" : ""}`}
				data-testid="drawer-overlay"
				aria-label="Close menu"
				tabIndex={isOpen ? 0 : -1}
				onClick={handleClose}
			/>

			<div className={`Drawer ${isOpen ? "Drawer--open" : ""}`} data-testid="drawer">
				<Condition check={showDiningTimer}>
					<div className="DrawerTimer" data-testid="drawer-timer">
						<DiningTimer />
					</div>
				</Condition>
				<nav className="DrawerNav">
					<button className="DrawerNavItem" data-testid="cart-button" onClick={handleCart}>
						{t("cartPage.title")}
					</button>
					<button
						className="DrawerNavItem"
						data-testid="order-history-button"
						onClick={handleOrderHistory}
					>
						Order History
					</button>
				</nav>
			</div>
		</>
	);
};

export default HamburgerDrawer;
